import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/prototype/classes.js";
import InlineSvg from 'vue-inline-svg';
import VueMeta from 'vue-meta'
import VueMatomo from 'vue-matomo';
import { initMatomoTracking } from "@/utils/MatomoTracking.js";

import "./permission.js";
import "@/assets/scss/app.scss";

import { LoginController } from "@/controller";
import { readPkceVerifier, clearPkceVerifier } from "@/utils/Pkce";


const params = new URLSearchParams(window.location.search);
const code = params.get("code");
if (code) {
  const verifier = readPkceVerifier();
  LoginController.doLogin(code, verifier);
  clearPkceVerifier();
  window.history.replaceState({}, document.title, window.location.pathname);
}

//Vue.use(VueMaterial);
Vue.component('inline-svg', InlineSvg);
Vue.use(VueMeta)

if (process.env.VUE_APP_MATOMO_HOST && process.env.VUE_APP_MATOMO_SITE_ID) {
  Vue.use(VueMatomo, {
    host: process.env.VUE_APP_MATOMO_HOST,
    siteId: process.env.VUE_APP_MATOMO_SITE_ID,
    router,
    disableCookies: true,
    enableLinkTracking: false,
  });
  initMatomoTracking();
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
